module.exports = __webpack_public_path__ + "img/10x_md.1e57e9f7.jpg";